import React from "react";

const LABELS = { volunteering: "Volunteering", social: "Social" };

/** Phase 7: colour-coded collective type badge.
 *  Green = volunteering, terracotta = social, split two-tone = both.
 *  Explicit leading-[14px] + items-center: the text is vertically centred and
 *  descenders can never clip (the "both" variant clips overflow for its
 *  rounded split, so the line box must fully contain the glyphs). */
export function CollectiveTypeBadge({ type, testId }) {
  const t = type || "volunteering";
  if (t === "both") {
    return (
      <span
        data-testid={testId || "collective-type-badge"}
        data-type="both"
        className="inline-flex items-stretch overflow-hidden rounded-full text-[10px] leading-[14px] font-semibold uppercase tracking-wide border border-neutral-200 shrink-0"
      >
        <span className="flex items-center bg-forest/10 text-forest px-2 py-0.5">Volunteering</span>
        <span className="flex items-center bg-terracotta/10 text-terracotta px-2 py-0.5 border-l border-neutral-200">Social</span>
      </span>
    );
  }
  const cls = t === "social" ? "bg-terracotta/10 text-terracotta" : "bg-forest/10 text-forest";
  return (
    <span
      data-testid={testId || "collective-type-badge"}
      data-type={t}
      className={`inline-flex items-center rounded-full text-[10px] leading-[14px] font-semibold uppercase tracking-wide px-2 py-0.5 shrink-0 ${cls}`}
    >
      {LABELS[t] || t}
    </span>
  );
}
